<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div  class="div-query-banner" >
          <a-form-item class="form-width-210" label="正测试"   >
            <a-radio-group name="fileType" v-model="queryParam.isFormal">
              <a-radio v-for="item in dictTestOrBeta" :key="item.label" :value="item.value">
                {{item.label}}
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="服务器" class="form-width-400"  >
            <a-select   v-model="queryParam.dbSourceId" :options="dictDataSourceOptions" >
            </a-select>
          </a-form-item>
          <a-form-item label="订单" class="form-width-400"  >
            <a-input   v-model="queryParam.orderNo"  >
            </a-input>
          </a-form-item>
          <a-button type="primary" class="query-banner-btn" @click="handleSubmit" :loading="loadingSubmit"  style="margin-left: 21px">确定</a-button>
          <a-button type="primary" class="query-banner-btn" @click="handleSearch" icon="search" :loading="loadingSubmit"  style="margin-left: 21px">搜索</a-button>
          <a-button type="primary" class="query-banner-btn" @click="handleSearchReset" icon="reload" :loading="loadingSubmit"  style="margin-left: 21px">重置</a-button>
        </div>
      </a-form>
    </div>
    <div class="table-operator">
    </div>
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">
        <a slot="browsepdf" slot-scope="text" @click="handleBrowse(text)"  >查看</a>
        <span slot="action" slot-scope="text, record">
          <a v-has="'technologyFileBrowse:add'" @click="handleEdit(record)"  :key="technologyFileBrowseKey"  >编辑</a>
          <a-divider  v-has="'technologyFileBrowse:add'" :key="technologyFileBrowseKey" type="vertical" />
          <a-dropdown   v-has="'technologyFileBrowse:add'" :key="technologyFileBrowseKey" >
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TechnologyFileBrowseModal from './modules/TechnologyFileBrowseModal'
  import {PaperlessMixin} from './MixinsOfGisPaperless.js'
  import {  getAction } from '@/api/manage'
  import {  execERPGHomeOrderDataByBom } from '@/api/api'
  import Vue from 'vue'
  
  import { filterObj } from '@/utils/util';

  const DATABASE_Source_value="DATABASE_Source_value"
  export default {
    mixins:[JeecgListMixin,PaperlessMixin],
    components: {
      TechnologyFileBrowseModal
    },
    data () {
      return {
        // 表头
        columns: [
          // {
          //   title: '#',
          //   dataIndex: '',
          //   key:'rowIndex',
          //   width:60,
          //   align:"center",
          //   customRender:function (t,r,index) {
          //     return parseInt(index)+1;
          //   }
          // },
          {
            title:'订单号',
            align:"center",
            dataIndex: 'orderCode',
            width:"170px"
          },
          {
            title:'导入时间',
            align:"center",
            dataIndex: 'createTime',
            width:"170px",
            customRender:function (text) {
              return !text?"":(text.length>16?text.substr(0,16):text)
            }
          },
          {
            title:'导入结果',
            align:"center",
            dataIndex: 'importResult',
            width:"170px",
            customRender:function (text) {
              return text=="0"?"成功":"失败"
            }
          },
          {
            title:'导入结果描述',
            align:"center",
            dataIndex: 'importResultDescribe',
            ellipsis:true
          }
        ],
        url: {
          list: "/factory.base/factoryGhomeDischargeLogs/list",
          delete: "/factory.base/factoryGhomeDischargeLogs/delete",
          deleteBatch: "/factory.base/factoryGhomeDischargeLogs/deleteBatch",
          exportXlsUrl: "/factory.base/factoryGhomeDischargeLogs/exportXls",
          importExcelUrl: "factory.base/factoryGhomeDischargeLogs/importExcel",
        },
        dictDataSourceOptions:[],
        dictCabinetType:[{'label':'厨柜','value':'厨柜'},{'label':'衣柜','value':'衣柜'}],
        dictTestOrBeta:[{'label':'测试','value':0},{'label':'正式','value':1}],
        loadingSubmit:false,
        disableMixinCreated:true,
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    async created() {
      await this.loginForUserName()
      this.getDataSorceDictOptions()
      this.loadData(1)
    },
    methods: {
      getDataSorceDictOptions(){
        getAction("/factory/base/ghomeDischargeUtils/list").then((res) => {
            if (res.success) {
              let localSourceValue=Vue.ls.get("DATABASE_Source_value")
              this.dictDataSourceOptions = res.result.map(item=>{
                if(localSourceValue===item.id){
                  this.$set(this.queryParam,"dbSourceId",localSourceValue)
                }
                return {label:item.dbUrlAndName,value:item.id}
              });
              Vue.ls.set("DATABASE_Source_value",this.queryParam.dbSourceId)
            }else{
                this.$message.warning("获取数据源失败"+res.message)
            }
        })
      },
      initDictConfig(){
      },
      handleSubmit(){
        Vue.ls.set("DATABASE_Source_value",this.queryParam.dbSourceId)
        if(!this.queryParam.isFormal&&this.queryParam.isFormal!==0){
          this.$message.error("请选择正式测试！")
          return
        }else if(!this.queryParam.dbSourceId&&this.queryParam.dbSourceId!==0){
           this.$message.error("请选择服务器！")
          return
        }else if(!this.queryParam.orderNo){
           this.$message.error("请输入订单号！")
          return
        }
        this.queryParam.orderNo=this.queryParam.orderNo.trim()
        this.loadingSubmit=true
        execERPGHomeOrderDataByBom(this.queryParam).then(res=>{
          if(res.code==200){
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
        }).finally(item=>{
          this.loadingSubmit=false
          this.handleSearch();
        })
      },
      getQueryParams () {
        //获取查询条件
        let sqp = {}
        if (this.superQueryParams) {
            sqp['superQueryParams'] = encodeURI(this.superQueryParams)
        }
        var param = Object.assign(sqp,this.isorter, this.filters);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        param.orderCode = this.queryParam.orderNo ? this.queryParam.orderNo : ''
        return filterObj(param);
      },
      handleSearch(){
        this.getQueryParams()
        this.loadData(1)
      },
      handleSearchReset(){
        this.queryParam = {}
        this.loadData(1)
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .div-query-banner{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin:20px 0px;
    &>*:nth-child(n){
      width:200px
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
     &>.query-banner-btn:nth-child(n){
      width:100px
    }
    &>.form-width-210{
      width:210px !important;
    }
    &>.form-width-400{
      width:400px !important;
    }
  }
</style>